"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class CustomPageHeading extends _react.default.Component {
  render() {
    const {
      children,
      title
    } = this.props;
    const titleRoot = document.getElementById('page-header-title');
    const customHeading = /*#__PURE__*/_react.default.createElement("div", {
      className: "page-header-title--left"
    }, title ?? children);
    if (typeof titleRoot !== 'undefined' && titleRoot) {
      return /*#__PURE__*/_reactDom.default.createPortal(customHeading, titleRoot);
    }
    return customHeading;
  }
}
exports.default = CustomPageHeading;
CustomPageHeading.propTypes = {
  title: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
//# sourceMappingURL=CustomPageHeader.js.map